"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
exports.InventoryLogAPI = {
    updateInventoryLog: function (companyId, inventoryLogId, newLogType, newOCSSubtype) {
        var postData = {
            newLogType: newLogType,
        };
        if (newOCSSubtype) {
            postData.newOCSSubtype = newOCSSubtype;
        }
        return index_1.axios.post("/api/v1/company/" + companyId + "/inventoryLog/" + inventoryLogId + "/modify", postData).then(function (response) {
            var inventoryLog = response.data.inventoryLog;
            return inventoryLog;
        });
    },
    getProductInventoryLogCount: function (company, filter) {
        return index_1.axios.get("/api/v1/company/" + company.id + "/inventoryLog/inventoryLogCount", {
            params: {
                startDate: filter.startDate,
                endDate: filter.endDate
            }
        })
            .then(function (response) {
            var inventoryLogCount = response.data;
            return inventoryLogCount;
        });
    }
};
//# sourceMappingURL=InventoryLogAPI.js.map